import { useEffect } from "react";
import NotificationsSettingsTable from "./NotificationsSettingsTable";
import HeaderColumnData from "../../services/models/notificationsSettingsTableModels/headerColumnData.model";
import BodyColumnData from "./BodyColumnData.model";
import NotificationSettingsServices from "../../services/NotificationSettingsServices";
import utils from "../../services/utils";
import useOrganizations from "../../services/utils/custom hooks/useOrganizations";
import useMediumValues from "../../services/utils/custom hooks/Notifications/useMediumValues";
import useOrganizationNotificationMediumValues from "../../services/utils/custom hooks/Notifications/useOrganizationMediumValues";
import useUserMediumValues from "../../services/utils/custom hooks/Notifications/useUserMediumValues";
import NotificationSettingsTableLoadingIndicator from "../global/LoadingIndicators/NotificationsSettingsTableLoadingIndicator";

interface UserNotificationMediumTableProps {
  tableColumns: HeaderColumnData[];
  fetching: boolean;
  error: boolean;
  tableBody: Array<BodyColumnData[]>;
  setTableBody: (data: Array<BodyColumnData[]>) => void;
  setTableColumns: (data: HeaderColumnData[]) => void;
  readOnly?: boolean;
}

function UserNotificationMediumTable({
  tableColumns,
  tableBody,
  setTableBody,
  setTableColumns,
  readOnly,
}: UserNotificationMediumTableProps): JSX.Element {
  const { data: mediumValues, isFetching: loadingMediums } = useMediumValues();
  const { data: userMediumValues, isFetching: loadingUserMediums } =
    useUserMediumValues();

  const loading = loadingMediums || loadingUserMediums;

  const NotificationsSettingsData = new NotificationSettingsServices(
    [], // No organizations needed
    mediumValues?.data ?? [],
    [], // No organization medium values needed
    userMediumValues?.data ?? [],
    undefined, // notificationTypes (optional)
    undefined, // userNotificationTypesValues (optional)
    true // isPersonalSettings flag
  );

  const dispatch = {};

  function handleSelectAll(id: string | number, value?: boolean) {
    setTableBody(
      NotificationsSettingsData.handleSelectAll(
        id,
        tableColumns,
        tableBody,
        dispatch,
        value
      ).tableBody
    );
    setTableColumns(
      NotificationsSettingsData.handleSelectAll(
        id,
        tableColumns,
        tableBody,
        dispatch,
        value
      ).tableColumn
    );
  }

  useEffect(() => {
    if (!loading) {
      NotificationsSettingsData.createPersonalOrganizationsSettingsData();
      setTableColumns(
        NotificationsSettingsData.getPersonalOrganizationsSettingsData()
          .tableColumn
      );
      setTableBody(
        NotificationsSettingsData.getPersonalOrganizationsSettingsData()
          .tableBody
      );
    }
  }, [loading]);

  const filteredValues = utils.getFilteredValues(tableBody);

  if (loading) {
    return <NotificationSettingsTableLoadingIndicator />;
  }
  return (
    <NotificationsSettingsTable
      tableColumns={tableColumns}
      onSelectAll={handleSelectAll}
      tableBody={tableBody}
      setTableBody={setTableBody}
      isEnabled={filteredValues}
      isPersonalSettingsNotificationMedium
      readOnly={readOnly}
    />
  );
}

export default UserNotificationMediumTable;
